import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolAdminService } from "../services/schooladmin.service";
import { LogDetailComponent } from "./log-detail/log-detail.component";
import { logModel } from "./logModel";
import * as moment from "moment";

@Component({
	selector: "app-view-application-logs",
	templateUrl: "./view-application-logs.component.html",
	styleUrls: ["./view-application-logs.component.css"],
})
export class ViewApplicationLogsComponent implements OnInit {
	constructor(
		private schoolAdminService: SchoolAdminService,
		private schoolService: SchoolService,
		private dialogService: DialogService,
		private selectService: SchoolselectorService
	) {}

	ngOnInit(): void {
		//Load Data
		// this.loadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		// this.loadApplicationForLogList();

		//
		//Testing:
		//

		// let val1: logModel = {
		//   ApplicationLogID: 0,
		//   DateAndTime: new Date(),
		//   ModuleName: "Test Module",
		//   Type: "Test Type",
		//   Message: "This is an example entry to test the component",
		//   UserName: "Super User"
		// };

		// let val2: logModel = {
		//   ApplicationLogID: 1,
		//   DateAndTime: new Date(),
		//   ModuleName: "Module X",
		//   Type: "Type 4",
		//   Message: "This is an example entry to test the component",
		//   UserName: "Steve"
		// };

		// this.logs.unshift(val1);
		// this.logs.unshift(val2);
	}

	valData = {
		SchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		StartTime: new Date(),
		EndTime: new Date(),
		ApplicationKey: "",
		ModuleName: "",
		SelectedLog: {
			ApplicationLogID: -1,
			DateAndTime: new Date(),
			ModuleName: "=",
			Type: "=",
			Message: "",
			UserName: "",
		},
		//Filtering
		NormalMessage: false,
		ProcessStart: false,
		ProcessComplete: false,
		HandledError: false,
		CriticalError: false,
	};

	errorMessage: any;
	applicationForLogList: any = [];
	applicationLogList: any = [];
	moduleList: any = [];
	SchoolList: any = [];

	loading: any = false;
	subscription: any;

	cols = [
		{ field: "DateAndTimeDesc", header: "Date and Time" },
		{ field: "Type", header: "Type" },
		{ field: "ModuleName", header: "Module Name" },
		{ field: "Message", header: "Message" },
		{ field: "UserName", header: "User Name" },
	];

	logs: logModel[] = [];

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	//  Load Data
	///////////////////////////////////////////////////
	//School List
	loadSchoolList() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.SchoolList = response;
				this.valData.SchoolID = this.SchoolList[0].SchoolID;
			},
			(error) => {}
		);
	}

	//Application List
	loadApplicationForLogList() {
		var result = this.schoolAdminService.loadApplicationForLogList("", this.valData.SchoolID);
		result.subscribe(
			(response) => {
				this.applicationForLogList = response;
				this.valData.ApplicationKey = this.applicationForLogList[0].ApplicationKey;
				this.loadModuleList();
			},
			(error) => {}
		);
	}

	//Module List
	loadModuleList() {
		var result = this.schoolAdminService.loadModuleList("", this.valData.ApplicationKey);
		result.subscribe(
			(response) => {
				this.moduleList = response;
				this.valData.ModuleName = this.moduleList[0].ModuleName;
			},
			(error) => {}
		);
	}

	//Application Data List
	loadApplicationLogList() {
		this.loading = true;

		//Create local variables and set them to the start and end date
		var SD = this.valData.StartDate;
		var ED = this.valData.EndDate;

		//////Date Time, seconds >= 60

		//Add start and end time to SD and ED
		SD.setHours(this.valData.StartTime.getHours());
		SD.setMinutes(this.valData.StartTime.getMinutes());
		//SD.setSeconds(this.valData.StartTime.getSeconds());
		SD.setSeconds(0);

		ED.setHours(this.valData.EndTime.getHours());
		ED.setMinutes(this.valData.EndTime.getMinutes());
		//ED.setSeconds(this.valData.EndTime.getSeconds());
		ED.setSeconds(0);

		//Format the time
		//var BeginDT = moment(SD).format("YYYY-MM-DD HH:MM:SS.000");
		//var EndDT = moment(ED).format("YYYY-MM-DD HH:MM:SS.000");

		var BeginDT = moment(SD).format("YYYY-MM-DD HH:MM:00.000");
		var EndDT = moment(ED).format("YYYY-MM-DD HH:MM:00.000");

		var Options = "";

		var OptList = [
			{
				Include: this.valData.NormalMessage,
				StringVal: "N",
			},
			{
				Include: this.valData.ProcessStart,
				StringVal: "S",
			},
			{
				Include: this.valData.ProcessComplete,
				StringVal: "T",
			},
			{
				Include: this.valData.HandledError,
				StringVal: "E",
			},
			{
				Include: this.valData.CriticalError,
				StringVal: "C",
			},
		];

		for (var i = 0; i < OptList.length; i++) {
			if (OptList[i].Include) {
				Options += OptList[i].StringVal + "|";
			}
		}

		Options = Options.substring(0, Options.length - 1);

		var result = this.schoolAdminService.loadApplicationLogList("", BeginDT, EndDT, this.valData.ApplicationKey, Options, this.valData.ModuleName); //////////////
		result.subscribe(
			(response) => {
				this.applicationLogList = response;
				this.UpdateData();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	//Parse Data into Table's Format
	UpdateData() {
		this.logs = [];

		for (var i = 0; i < this.applicationLogList.length; i++) {
			var next = this.applicationLogList[i];

			let val1: logModel = {
				ApplicationLogID: next.ApplicationLogID,
				DateAndTime: next.LogDT,
				DateAndTimeDesc: moment(new Date(next.LogDT)).format("MM/DD/YYYY h:mm a"),
				Type: next.LogMessageTypeCD,
				ModuleName: next.LogModuleName,
				Message: next.LogText,
				UserName: next.User_PersonName,
			};

			this.logs = [...this.logs, val1];
		}

		this.loading = false;
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	//  Buttons
	///////////////////////////////////////////////////

	SearchLogs() {
		this.loadApplicationLogList();
	}

	onRowDblClick(val) {
		this.valData.SelectedLog = val;
		this.onViewLog();
	}

	onViewLog() {
		//Error Handling
		if (this.valData.SelectedLog.ApplicationLogID == -1) {
			this.errorMessage = "Select a Log to view";
			return;
		}

		//Get Data
		var entry;
		for (var i = 0; i < this.applicationLogList.length; i++) {
			if (this.applicationLogList[i].ApplicationLogID == this.valData.SelectedLog.ApplicationLogID) {
				entry = this.applicationLogList[i];
				break;
			}
		}

		//Open popup
		var ref = this.dialogService.open(LogDetailComponent, {
			header: "View Log Details",
			width: "fit-content",
			data: {
				Data: entry, ///////
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	//  Events
	///////////////////////////////////////////////////

	//Option Change

	//Filter change?

	onSchoolChange(value) {
		//Set Data
		this.valData.SchoolID = value;

		//Load Applications based on the selected school
		this.loadApplicationForLogList();
	}

	onApplicationKeyChange(value) {
		//Set Data
		this.valData.ApplicationKey = value;

		//Load Modules based on the selected application
		this.loadModuleList();
	}

	onRowSelect(value) {
		this.errorMessage = "";
		this.valData.SelectedLog = value.data;
	}

	onRowUnselect(value) {
		this.valData.SelectedLog = {
			ApplicationLogID: -1,
			DateAndTime: new Date(),
			ModuleName: "=",
			Type: "=",
			Message: "",
			UserName: "",
		};
	}

	///////////////////////////////////////////////////
}
